import { animate, AnimationOptions, AnimationSequence } from 'motion'

export const landingPage = () => {
    if (!document.body.classList.contains('page-template-landing-page')) return

    let video = document.querySelector<HTMLVideoElement>('.landing-bg video')
    if (!(video instanceof HTMLVideoElement)) return

    let landingTitle = document.querySelector('.landing-title-text')
    let landingBtn = document.querySelector('.landing-btn')
    let landingLogo = document.querySelector('.landing-logo')

    setTimeout(() => {
        document.body.classList.add('landing-page-loaded')

        let animOpts: AnimationOptions = { duration: 0.5, ease: 'easeOut' }

        let sequence: AnimationSequence = []
        if (landingLogo) sequence.push([landingLogo, { opacity: [0, 1] }, animOpts])
        if (landingBtn) sequence.push([landingBtn, { opacity: [0, 1] }, { at: 0.4, ...animOpts }])
        if (landingTitle)
            sequence.push([
                landingTitle,
                { opacity: [0, 1], transform: ['scale(1.2)', 'scale(1)'] },
                { at: 0.3, ...animOpts },
            ])

        animate(sequence)
    }, 500)
}
